import React from "react";
import { useSelector } from "react-redux";
import MyRouter from "./routers/index";
import { Helmet, HelmetProvider } from "react-helmet-async";

function App() {
 var Bugsnag = require('@bugsnag/js')
 Bugsnag.start({ apiKey: '070d5a4deb1f18cf2ddd8fbdabca6492' })
  return (
    <HelmetProvider>
      <Helmet>
        <title>Vijaydeep</title>
        <meta
          name="description"
          content="Vijaydeep"
        />
      </Helmet>

      {/* MAIN APP */}
      <div className="bg-white text-base dark:bg-slate-900 text-slate-900 dark:text-slate-200">
         <MyRouter />
      </div>
    </HelmetProvider>
  );
}

export default App;
